export default function LoginRequired(store) {
  return store.getters["user/user"];
}
